<template>
    <div>
        <div class="pagemain">
            <div class="page2">
                <div class="left_div">
                    <div :class="item.study_id == study_id ? 'left_item2' : 'left_item'" v-for="(item, i) in title_list"
                        :key="i" @click="get_study_content(item)">
                        <div class="title">
                            <div class="count">
                                {{ i + 1 }}
                            </div>
                            <div class="title_txt">
                                {{ item.title }}
                            </div>

                        </div>

                        <div class="status_div">
                            <div class="read_time">
                                {{ item.read_time }}
                            </div>
                            <div class="yiyuexi" v-if="item.status">
                                已学习
                            </div>
                            <div class="weiyuexi" v-else>
                                待学习
                            </div>
                        </div>

                    </div>
                </div>
                <div class="bodymarkdown">
                    <Spin v-if="loading" fix>
                        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                        <div>玩命加载中</div>
                    </Spin>
                    <div v-if="ifram_url == ''" class="conent_null">
                        👈请点击左侧菜单进行学习
                    </div>
                    <iframe style="width: 100%; height: 100%; border: none" @error="iframeError" @load="iframe_load"
                        :src="ifram_url"></iframe>
                    <!-- <div class="markdown-body" v-html="htmlContent"></div> -->
                </div>
            </div>


        </div>

    </div>
</template>

<script>


import { open_new_page, http, get_browser_id } from "@/utils/http";

export default {
    name: 'study',
    data() {

        return {

            title_list: [],
            ifram_url: '',
            htmlContent: '',
            loading: false,
            study_id: ''
        }
    },
    watch: {
        ifram_url(newUrl) {
            this.loading = true;  // URL 变化时重置加载状态
        }
    },
    mounted() {
        this.open();
    },
    methods: {

        open() {
            this.get_study_title();
        },
        iframeError() {
            this.loading = false;
            console.error('Iframe 加载失败');
        },
        iframe_load(e) {
            console.log('iframe_加载好了')
            this.loading = false
        },

        //
        get_study_title() {
            var that = this;
            var obj = {};
            http(
                "post",
                process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/study_title_list",
                obj,
                true,
                "staff"
            )
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 0) {
                        that.title_list = res.data.data_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
        get_study_content(item) {
            var that = this;
            this.study_id = item.study_id
            var obj = {
                study_id: item.study_id
            };
            this.loading = true
            http(
                "post",
                process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/study_content",
                obj,
                true,
                "staff"
            )
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 0) {
                        if(that.ifram_url!=''){
                            that.loading=false
                        }
                        that.ifram_url = res.data.study_item.content
                       
                        
                        // that.get_study_title();
                        // const md = new MarkdownIt();
                        // const htmlContent = computed(() => md.render(res.data.study_item.content || ''));
                        // that.htmlContent = htmlContent

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.count {
    font-size: 13px;
    background: #e3e3e3;
    border-radius: 3px;
    width: 20px;
    color: #c4c4c4;
    justify-content: center;
    display: flex;
    margin-right: 10px;
    align-items: center;
}

.title {
    display: flex;
}

.read_time {
    font-size: 13px;
    color: #ccc;
    margin-right: 10px;

}

.conent_null {
    display: flex;
    justify-content: center;
    height: 100vh;
    align-items: center;
    font-weight: 600;
    font-size: 16px;
}

.demo-spin-col .circular {
    width: 25px;
    height: 25px;
}

.demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(180deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
}

.page2 {
    display: flex;
}

.status_div {
    display: flex;
    align-items: end;
    justify-content: end;
    margin-top: 5px;
}

.yiyuexi {
    background-color: #18c64c;
    color: #fff;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 12px;
}

.weiyuexi {
    background-color: #fd2525;
    color: #fff;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 12px;
}

.left_div {
    width: 240px;
    height: 100vh;
    flex-shrink: 0;
    border-right: 2px solid #eaeaea;
}

.left_item {
    padding: 10px;
    cursor: pointer;
    color: #333;
    border-bottom: 1px solid #ececec;
}

.left_item2 {
    padding: 10px;
    cursor: pointer;
    background-color: #0466dd;
    color: #fff;
    border-bottom: 1px solid #ececec;
}


.left_item:hover {
    background-color: #0974f7;
    color: #fff;
}


.bodymarkdown {
    height: 100vh;
    overflow: auto;
    flex: 1;
    position: relative;
     /* 隐藏滚动条但保留滚动功能 */
     scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE/Edge */
}



/* 针对 Webkit 浏览器（Chrome, Safari, Opera） */
.bodymarkdown::-webkit-scrollbar {
    display: none; /* 完全隐藏滚动条 */
}

.pagemain {
    width: calc(100vw - 120px);
    min-width: 800px;
    min-height: 100vh;
    overflow: auto;
    overflow-y: scroll;
    background: #ffffff;
}
</style>